/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum Generator`)
};

const es_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de Lorem Ipsum`)
};

const de_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum Generator`)
};

const nl_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum Generator`)
};

const fr_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur Lorem Ipsum`)
};

const it_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di Lorem Ipsum`)
};

const pt_br2_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Lorem Ipsum`)
};

const pt_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador Lorem Ipsum`)
};

const ja_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum生成器`)
};

const zh_li_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum 生成器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_tool_name", locale)
	if (locale === "en") return en_li_tool_name(inputs)
	if (locale === "es") return es_li_tool_name(inputs)
	if (locale === "de") return de_li_tool_name(inputs)
	if (locale === "nl") return nl_li_tool_name(inputs)
	if (locale === "fr") return fr_li_tool_name(inputs)
	if (locale === "it") return it_li_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_li_tool_name(inputs)
	if (locale === "pt") return pt_li_tool_name(inputs)
	if (locale === "ja") return ja_li_tool_name(inputs)
	return zh_li_tool_name(inputs)
};